const TestimonialsComingSoon = () => (
  <section className="max-w-5xl">
    <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#22C55E]">04 / TESTIMONIALS</p>
    <div className="mt-16 max-w-2xl border-l-2 border-[#22C55E] pl-6 sm:pl-8">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#8B8B93]">COMING SOON</p>
      <h1 className="mt-5 text-4xl font-mono font-bold text-[#EDEDEF] sm:text-6xl">Testimonials are on the way.</h1>
      <p className="mt-6 text-base leading-8 text-[#8B8B93]">
        I am gathering approved feedback from clients, collaborators, and mentees. This page will be updated with verified testimonials as they become available.
      </p>
      <div className="mt-10 inline-flex items-center gap-3 rounded-full border border-[#27272A] bg-[#141416] px-4 py-2 font-mono text-xs uppercase tracking-wider text-[#4ADE80]">
        <span className="h-2 w-2 rounded-full bg-[#22C55E]" />
        Verified recommendations in progress
      </div>
    </div>
  </section>
);

export default TestimonialsComingSoon;
